var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckContained(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 19.2 19.2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.1136 7.9864L8.7 11.4L7.5364 10.2364M9.6 2.4C5.62355 2.4 2.4 5.62355 2.4 9.6C2.4 13.5765 5.62355 16.8 9.6 16.8C13.5765 16.8 16.8 13.5765 16.8 9.6C16.8 5.62355 13.5765 2.4 9.6 2.4Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckContained);
export default __webpack_public_path__ + "static/media/check-contained.245c48c87c21bb4072f849e2c21f72bb.svg";
export { ForwardRef as ReactComponent };